import { Component } from '@angular/core';

@Component({
  selector: 'app-blocks-icon',
  standalone: true,
  host: { class: 'ui-icon' },
  templateUrl: './blocks-icon.component.html',
  styleUrl: '../icon-base.scss'
})
export class BlocksIconComponent {}
